/**

// Check if debug mode is enabled (global)
const urlParams = new URLSearchParams(window.location.search);

 * Date Filters Module - Обработка фильтров дат
 * 
 * Phase 6: Filters and Forms Migration
 * Migrated from main.js date filtering logic
 */


/**
 * Date Filters Manager Class - handles date range filtering
 */
class DateFiltersManager {
    constructor() {
        this.dateRange = {
            from: '',
            to: ''
        };
        
        this.elements = {
            dateFrom: '.filter-date-from',
            dateTo: '.filter-date-to',
            dateInputs: '.filter-date'
        };
        
        this.callbacks = [];
        this.debounceTimeout = null;
        this.debounceDelay = 250;
        
        // Initialization logging only in debug mode
    }
    
    /**
     * Initialize date filters
     * @param {Object} options - Configuration options
     * @returns {boolean} Success status
     */
    initialize(options = {}) {
        try {
            const config = {
                debounceDelay: 250,
                autoSetup: true,
                ...options
            };
            
            this.debounceDelay = config.debounceDelay;
            
            if (config.autoSetup) {
                this.setupEventListeners();
            }
            
            // Extract initial dates from URL
            this.extractInitialDates();

            // Ensure button text and label are translated on initialization
            // This function will be called multiple times to ensure translation is applied
            const applyInitialTranslation = () => {
                try {
                    const btn = document.getElementById('date-range-toggle');
                    if (!btn) return false;
                    
                    const buttonText = btn.querySelector('.drp-button-text');
                    const labelTo = btn.querySelector('.drp-label-to');
                    if (!buttonText) return false;
                    
                    const from = this.dateRange.from || '';
                    const to = this.dateRange.to || '';
                    
                    // If no dates selected, ensure translation is applied
                    if (!from && !to) {
                        const translateKey = 'drp_button_text';
                        buttonText.setAttribute('data-translate', translateKey);
                        
                        // Apply translation immediately if TranslationApplier is ready
                        if (window.TranslationApplier && typeof window.TranslationApplier.apply === 'function') {
                            window.TranslationApplier.apply();
                            return true;
                        } else if (window.TranslationRegistry && typeof window.TranslationRegistry.translate === 'function') {
                            // Fallback: manual translation if TranslationApplier not ready
                            const lang = window.LanguageManager ? window.LanguageManager.getCurrentLanguage() : (window.LANG || 'EN');
                            const translatedText = window.TranslationRegistry.translate(translateKey, lang);
                            if (translatedText !== translateKey) {
                                buttonText.textContent = translatedText;
                                return true;
                            }
                        }
                    } else {
                        // If dates are selected, ensure label translation is applied
                        if (labelTo && labelTo.style.display !== 'none') {
                            if (window.TranslationApplier && typeof window.TranslationApplier.apply === 'function') {
                                window.TranslationApplier.apply();
                                return true;
                            }
                        }
                    }
                    return false;
                } catch(_) {
                    return false;
                }
            };
            
            // Try immediately
            if (!applyInitialTranslation()) {
                // Retry after a delay if element not found or translations not ready
                setTimeout(() => {
                    if (!applyInitialTranslation()) {
                        // Final retry after longer delay
                        setTimeout(applyInitialTranslation, 500);
                    }
                }, 100);
            }

            // Chip UI hookup
            try {
                // Note: dateRangeChanged event is handled in filter-controller.events.js
                // This listener is kept for compatibility but URL update is handled there
                window.addEventListener('dateRangeChanged', (e) => {
                    // Update dropdown button label instead of separate chip
                    const btn = document.getElementById('date-range-toggle');
                    if (!btn) return;
                    const from = e.detail?.from || '';
                    const to = e.detail?.to || '';
                    
                    // Show/hide labels based on date selection
                    const labelTo = btn.querySelector('.drp-label-to');
                    const buttonText = btn.querySelector('.drp-button-text');
                    
                    if (from || to) {
                        // Show labels when dates are selected
                        if (labelTo) {
                            labelTo.style.display = 'flex';
                            // Apply translation to label when showing
                            if (window.TranslationApplier && typeof window.TranslationApplier.apply === 'function') {
                                window.TranslationApplier.apply();
                            }
                        }
                        
                        const top = from || '—';
                        const bottom = to || '—';
                        if (buttonText) {
                            // Remove data-translate attribute when showing dates (dates are not translatable)
                            buttonText.removeAttribute('data-translate');
                            buttonText.innerHTML = `<span class="d-block text-start" style="line-height:1.1;">
                              <span class="d-block fw-semibold">${top}</span>
                              <span class="d-block fw-semibold" style="margin-top:3px;">${bottom}</span>
                            </span>`;
                        }
                    } else {
                        // Hide labels when no dates selected
                        if (labelTo) labelTo.style.display = 'none';
                        if (buttonText) {
                            // Restore data-translate attribute and apply translation
                            const translateKey = 'drp_button_text';
                            buttonText.setAttribute('data-translate', translateKey);
                            
                            // Apply translation immediately
                            if (window.TranslationApplier && typeof window.TranslationApplier.apply === 'function') {
                                window.TranslationApplier.apply();
                            } else {
                                // Fallback: manual translation if TranslationApplier not available
                                let translatedText = translateKey;
                                if (window.TranslationRegistry && typeof window.TranslationRegistry.translate === 'function') {
                                    const lang = window.LanguageManager ? window.LanguageManager.getCurrentLanguage() : (window.LANG || 'EN');
                                    translatedText = window.TranslationRegistry.translate(translateKey, lang);
                                } else if (window.LanguageManager && typeof window.LanguageManager.translate === 'function') {
                                    translatedText = window.LanguageManager.translate(translateKey);
                                }
                                buttonText.textContent = translatedText;
                            }
                        }
                    }
                });
                // (removed) Only-with-date toggle
            } catch(_){}
            
            // Initialization logging only in debug mode
            
            return true;
            
        } catch (error) {
            if (debugMode === '1') {
                console.error('[DateFiltersManager] Initialization failed:', error);
            }
            return false;
        }
    }
    
    /**
     * Setup event listeners for date inputs
     */
    setupEventListeners() {
        $(this.elements.dateInputs).on('input', (event) => { this.handleDateInput(event); });
        // React immediately when mask completes a valid pattern
        $(this.elements.dateInputs).on('keyup', (event) => {
            const val = $(event.target).val() || '';
            if (/^\d{2}-\d{2}-\d{2}$/.test(val) || /^\d{4}-\d{2}-\d{2}$/.test(val) || /^\d{6}$/.test(val) || /^\d{8}$/.test(val)) {
                this.handleDateChange(event);
            }
        });
        
        $(this.elements.dateInputs).on('change', (event) => {
            this.handleDateChange(event);
        });
        
        // Event listeners setup completed logging only in debug mode
    }
    
    /**
     * Handle date input event (with debouncing)
     * @param {Event} event - Input event
     */
    handleDateInput(event) {
        const isFrom = $(event.target).hasClass('filter-date-from');
        const value = $(event.target).val();
        
        // Update internal state immediately
        if (isFrom) {
            this.dateRange.from = value;
        } else {
            this.dateRange.to = value;
        }
        
        // Clear previous timeout
        if (this.debounceTimeout) {
            clearTimeout(this.debounceTimeout);
        }
        
        // Set new timeout for debounced callback
        this.debounceTimeout = setTimeout(() => {
            this.triggerCallbacks();
            // Update filterController activeFilters (URL will be updated when search is executed)
            if (window.filterController) {
                if (isFrom) {
                    window.filterController.activeFilters.dateFrom = value;
                } else {
                    window.filterController.activeFilters.dateTo = value;
                }
            }
            // Unified path: apply filters to update main UI
            // Apply filters immediately (without URL update)
            if (window.filterManager && typeof window.filterManager.applyFilters === 'function') {
                window.filterManager.applyFilters(false); // false = don't update URL immediately
            }
            // Trigger debounced search to update URL when search executes
            if (window.filterManager && typeof window.filterManager.triggerDebouncedSearch === 'function') {
                window.filterManager.triggerDebouncedSearch();
            }
        }, this.debounceDelay);
        
        if (window.HyperLog) {
            window.HyperLog.debug('[DateFiltersManager] Date input changed', {
                isFrom: isFrom,
                value: value,
                dateRange: this.dateRange
            });
        }
    }
    
    /**
     * Handle date change event (immediate)
     * @param {Event} event - Change event
     */
    handleDateChange(event) {
        const isFrom = $(event.target).hasClass('filter-date-from');
        const value = $(event.target).val();
        
        // Validate date format
        if (value && !this.isValidDate(value)) {
            if (debugMode === '1') {
                console.warn('[DateFiltersManager] Invalid date format:', value);
            }
            return;
        }
        
        // Update state
        if (isFrom) {
            this.dateRange.from = value;
        } else {
            this.dateRange.to = value;
        }
        
        // Validate date range
        if (this.dateRange.from && this.dateRange.to) {
            if (!this.isValidDateRange(this.dateRange.from, this.dateRange.to)) {
                if (debugMode === '1') {
                console.warn('[DateFiltersManager] Invalid date range:', this.dateRange);
            }
            }
        }
        
        // Update filterController activeFilters for URL sync
        if (window.filterController) {
            if (isFrom) {
                window.filterController.activeFilters.dateFrom = value;
            } else {
                window.filterController.activeFilters.dateTo = value;
            }
            // URL will be updated when search is executed (debounce) - don't update here
        }
        
        // Sync date filters to filterController before applying filters
        if (window.filterController && window.filterController.activeFilters) {
            window.filterController.activeFilters.dateFrom = this.dateRange.from || '';
            window.filterController.activeFilters.dateTo = this.dateRange.to || '';
        }
        
        // Trigger immediate callback
        this.triggerCallbacks();
        
        // Skip URL update if restoring state from browser history
        const isRestoring = window.__isRestoringBrowserState === true;
        if (isRestoring) {
            return;
        }
        
        // Unified path: apply filters to update main UI
        // Apply filters immediately (without URL update)
        if (window.filterManager && typeof window.filterManager.applyFilters === 'function') {
            window.filterManager.applyFilters(false); // false = don't update URL immediately
        }
        
        // Trigger debounced search to update URL when search executes (same as category filters)
        if (window.filterManager && typeof window.filterManager.triggerDebouncedSearch === 'function') {
            window.filterManager.triggerDebouncedSearch();
        }
        
        if (window.HyperLog) {
            window.HyperLog.debug('[DateFiltersManager] Date changed', {
                isFrom: isFrom,
                value: value,
                dateRange: this.dateRange
            });
        }
    }
    
    /**
     * Set date range programmatically
     * @param {string} dateFrom - From date (YYYY-MM-DD format)
     * @param {string} dateTo - To date (YYYY-MM-DD format)
     * @param {boolean} skipUrlUpdate - If true, skip URL update (for state restoration)
     */
    setDateRange(dateFrom, dateTo, skipUrlUpdate = false) {
        try {
            // Normalize inputs: convert null/undefined to empty string, trim whitespace
            const normalizedFrom = (dateFrom && typeof dateFrom === 'string') ? dateFrom.trim() : '';
            const normalizedTo = (dateTo && typeof dateTo === 'string') ? dateTo.trim() : '';
            
            // Validate inputs (only if non-empty)
            if (normalizedFrom && !this.isValidDate(normalizedFrom)) {
                throw new Error(`Invalid from date: ${dateFrom}`);
            }
            
            if (normalizedTo && !this.isValidDate(normalizedTo)) {
                throw new Error(`Invalid to date: ${dateTo}`);
            }
            
            if (normalizedFrom && normalizedTo && !this.isValidDateRange(normalizedFrom, normalizedTo)) {
                throw new Error(`Invalid date range: ${normalizedFrom} to ${normalizedTo}`);
            }
            
            // Update internal state
            this.dateRange.from = normalizedFrom;
            this.dateRange.to = normalizedTo;
            
            // Update UI
            $(this.elements.dateFrom).val(this.dateRange.from);
            $(this.elements.dateTo).val(this.dateRange.to);
            
            // Sync with filterController
            if (window.filterController && window.filterController.activeFilters) {
                window.filterController.activeFilters.dateFrom = this.dateRange.from || '';
                window.filterController.activeFilters.dateTo = this.dateRange.to || '';
            }
            
            // Sync with filterManager
            if (window.filterManager && window.filterManager.activeFilters) {
                window.filterManager.activeFilters.dateFrom = this.dateRange.from || '';
                window.filterManager.activeFilters.dateTo = this.dateRange.to || '';
            }
            
            // Trigger callbacks (this will apply filters and update URL via debounce unless skipUrlUpdate is true)
            if (!skipUrlUpdate) {
                this.triggerCallbacks();
            } else {
                // When restoring state, only sync UI without triggering URL updates
                // Apply filters without URL update
                if (window.filterManager && typeof window.filterManager.applyFilters === 'function') {
                    window.filterManager.applyFilters(false); // false = don't update URL
                }
            }
            
        } catch (error) {
            if (debugMode === '1') {
                console.error('[DateFiltersManager] Error setting date range:', error);
            }
        }
    }
    
    /**
     * Get current date range
     * @returns {Object} Date range object
     */
    getDateRange() {
        return {
            from: this.dateRange.from,
            to: this.dateRange.to,
            hasRange: this.hasDateRange(),
            isValid: this.isValidCurrentRange()
        };
    }
    
    /**
     * Check if date range is set
     * @returns {boolean} True if either from or to date is set
     */
    hasDateRange() {
        return !!(this.dateRange.from || this.dateRange.to);
    }
    
    /**
     * Check if current date range is valid
     * @returns {boolean} True if range is valid
     */
    isValidCurrentRange() {
        if (!this.hasDateRange()) return true;
        
        if (this.dateRange.from && !this.isValidDate(this.dateRange.from)) return false;
        if (this.dateRange.to && !this.isValidDate(this.dateRange.to)) return false;
        
        if (this.dateRange.from && this.dateRange.to) {
            return this.isValidDateRange(this.dateRange.from, this.dateRange.to);
        }
        
        return true;
    }
    
    /**
     * Clear date filters
     */
    clearDateFilters() {
        this.dateRange.from = '';
        this.dateRange.to = '';
        
        $(this.elements.dateInputs).val('');
        
        this.triggerCallbacks();
        
        if (window.HyperLog) {
            window.HyperLog.debug('[DateFiltersManager] Date filters cleared');
        }
    }
    
    /**
     * Validate date format (YYYY-MM-DD or similar)
     * @param {string} dateString - Date string to validate
     * @returns {boolean} True if valid
     */
    isValidDate(dateString) {
        if (!dateString || typeof dateString !== 'string') return false;
        
        // Allow empty string as valid (means clear date)
        if (dateString.trim() === '') return true;
        
        // Basic date format patterns
        const patterns = [
            /^\d{4}-\d{2}-\d{2}$/, // YYYY-MM-DD
            /^\d{2}\/\d{2}\/\d{4}$/, // MM/DD/YYYY
            /^\d{2}\.\d{2}\.\d{4}$/, // DD.MM.YYYY
            /^\d{6}$/, // YYMMDD
            /^\d{8}$/ // YYYYMMDD
        ];
        
        const matchesPattern = patterns.some(pattern => pattern.test(dateString));
        if (!matchesPattern) return false;
        
        // Try to parse as Date
        try {
            const date = new Date(dateString);
            return date instanceof Date && !isNaN(date);
        } catch {
            return false;
        }
    }
    
    /**
     * Validate date range (from <= to)
     * @param {string} fromDate - From date
     * @param {string} toDate - To date
     * @returns {boolean} True if valid range
     */
    isValidDateRange(fromDate, toDate) {
        try {
            const from = new Date(fromDate);
            const to = new Date(toDate);
            
            return from <= to;
        } catch {
            return false;
        }
    }
    
    /**
     * Parse date string to Date object
     * @param {string} dateString - Date string
     * @returns {Date|null} Parsed date or null
     */
    parseDate(dateString) {
        if (!this.isValidDate(dateString)) return null;
        
        try {
            return new Date(dateString);
        } catch {
            return null;
        }
    }
    
    /**
     * Format date for display
     * @param {string|Date} date - Date to format
     * @param {string} format - Format type ('YYYY-MM-DD\', 'DD/MM/YYYY', etc.)
     * @returns {string} Formatted date string
     */
    formatDate(date, format = 'YYYY-MM-DD') {
        try {
            const dateObj = date instanceof Date ? date : new Date(date);
            
            if (isNaN(dateObj)) return '';
            
            const year = dateObj.getFullYear();
            const month = String(dateObj.getMonth() + 1).padStart(2, '0');
            const day = String(dateObj.getDate()).padStart(2, '0');
            
            switch (format) {
                case 'YYYY-MM-DD':
                    return `${year}-${month}-${day}`;
                case 'DD/MM/YYYY':
                    return `${day}/${month}/${year}`;
                case 'MM/DD/YYYY':
                    return `${month}/${day}/${year}`;
                case 'DD.MM.YYYY':
                    return `${day}.${month}.${year}`;
                default:
                    return `${year}-${month}-${day}`;
            }
        } catch {
            return '';
        }
    }
    
    /**
     * Extract initial dates from URL parameters
     */
    extractInitialDates() {
        try {
            // Check URL parameters for date filters
            const urlParams = new URLSearchParams(window.location.search);
            const dateFrom = urlParams.get('date-from') || urlParams.get('dateFrom') || '';
            const dateTo = urlParams.get('date-to') || urlParams.get('dateTo') || '';
            
            if (dateFrom || dateTo) {
                // Use skipUrlUpdate=true to prevent URL updates during initialization
                this.setDateRange(dateFrom, dateTo, true);
            }
            
        } catch (error) {
            if (debugMode === '1') {
                console.error('[DateFiltersManager] Error extracting initial dates:', error);
            }
        }
    }
    
    /**
     * Add callback for date filter changes
     * @param {Function} callback - Callback function
     */
    addCallback(callback) {
        if (typeof callback === 'function') {
            this.callbacks.push(callback);
        }
    }
    
    /**
     * Remove callback
     * @param {Function} callback - Callback to remove
     */
    removeCallback(callback) {
        const index = this.callbacks.indexOf(callback);
        if (index > -1) {
            this.callbacks.splice(index, 1);
        }
    }
    
    /**
     * Trigger all callbacks with current date range
     */
    triggerCallbacks() {
        const dateData = this.getDateRange();
        
        for (const callback of this.callbacks) {
            try {
                callback(dateData);
            } catch (error) {
                if (debugMode === '1') {
                console.error('[DateFiltersManager] Error in date filter callback:', error);
            }
            }
        }
    }
    
    /**
     * Get statistics about date filtering
     * @returns {Object} Statistics object
     */
    getStats() {
        return {
            hasDateRange: this.hasDateRange(),
            isValidRange: this.isValidCurrentRange(),
            dateRange: this.dateRange,
            callbackCount: this.callbacks.length,
            debounceDelay: this.debounceDelay
        };
    }
    
    /**
     * Destroy date filters manager
     */
    destroy() {
        try {
            // Clear timeout
            if (this.debounceTimeout) {
                clearTimeout(this.debounceTimeout);
                this.debounceTimeout = null;
            }
            
            // Remove event listeners
            $(this.elements.dateInputs).off('input change');
            
            // Clear state
            this.dateRange = { from: '', to: '' };
            this.callbacks = [];
            
            if (window.HyperLog) {
                window.HyperLog.debug('[DateFiltersManager] Destroyed');
            }
            
        } catch (error) {
            if (debugMode === '1') {
                console.error('[DateFiltersManager] Error destroying date filters:', error);
            }
        }
    }
}

// Create singleton instance
const dateFiltersManager = new DateFiltersManager();

// Export for use in other modules
export { dateFiltersManager };

// Global export for backward compatibility
window.dateFiltersManager = dateFiltersManager;

// Register with migration controller

// Module loaded logging only in debug mode 